// MonthlyPieChart.js
import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const Chart = ({ label, amount, statusCounts = {}, statusAmounts = {} }) => {
    const paidCount = statusCounts.paid || 0;
    const outstandingCount = statusCounts.outstanding || 0;

    const paidAmount = statusAmounts.paid || 0;
    const outstandingAmount = statusAmounts.outstanding || 0;
    const data = {
        labels: ['Outstanding', 'Paid'],
        datasets: [
            {
                data: [outstandingCount, paidCount],
                backgroundColor: ['#00cfff', '#006f4e'],
                borderWidth: 0
            }
        ]
    };

    const options = {
        plugins: {
            tooltip: {
                callbacks: {
                    // label: function (context) {
                    //     return `${context.parsed}`;
                    // }
                    label: function (context) {
                        const label = context.label;
                        const value = context.parsed;
                        const amount = label === 'Paid' ? paidAmount : outstandingAmount;
                        return [
                            `Total Invoices: ${value}`,
                            `Total Spent: $${amount.toFixed(2)}`
                        ];
                    }
                }
            },
            legend: {
                display: false,
                // labels: {
                //     usePointStyle: true,
                //     pointStyle: 'circle' 
                // }
            }
        },
        responsive: true,
        maintainAspectRatio: false
    };

    return (
        <div className="reportmap_1s">
            <div className="reportmap_1stext">
                <div className="thismonth">{label} <span>Total Spent</span></div>
                <div className="thisprice">${amount}</div>
            </div>
            <div style={{ width: '274px', height: 'auto' }}>
                <Pie data={data} options={options} />
            </div>
            {/* <p style={{ textAlign: 'center', marginTop: 10 }}>{label}</p> */}
        </div>

    );
};

export default Chart;
